import Box from '@eversports/klimt-primitives/legacy/Box'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Text from '@eversports/klimt-primitives/legacy/Text'
import TextField from '@eversports/klimt-primitives/legacy/TextField'
import { ChangeEvent, KeyboardEvent, useState } from 'react'

import SendMessageIcon from '../../../assets/icons/send-message.svg'
import { Localized, useIntl } from '../../../localization/react'
import useLoggedInUserType from '../hooks/use-logged-in-user-type'
import { UserType } from '../Match.types'

interface Props {
  onSubmit: ({ comment }: { comment: string }) => void
}

const NewCommentInput = ({ onSubmit }: Props) => {
  const intl = useIntl()
  const { userType } = useLoggedInUserType()
  const [comment, setComment] = useState<string>('')
  const isNonLoggedInUser = userType === UserType.EXTERNAL_GUEST

  const submitComment = () => {
    if (comment) {
      onSubmit({ comment })
      setComment('')
    }
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setComment(event.target.value)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      submitComment()
    }
  }

  return (
    <Box sx={{ p: 4, maxWidth: '520px', margin: 'auto' }}>
      {isNonLoggedInUser ? (
        <Text sx={{ textAlign: 'center' }}>
          <Localized id="non-logged-in-user-comment-disclaimer" />
        </Text>
      ) : (
        <TextField
          id="new-comment"
          aria-label={intl.addNewCommentPlaceholder()}
          placeholder={intl.addNewCommentPlaceholder()}
          value={comment}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          InputProps={{
            endAdornment: (
              <Box sx={{ cursor: 'pointer' }} onClick={submitComment}>
                <Icon src={SendMessageIcon} color={comment !== '' ? 'primary' : 'gray'} size="small" />
              </Box>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 1,
            },
          }}
          fullWidth
        />
      )}
    </Box>
  )
}

export default NewCommentInput
